import { render, staticRenderFns } from "./BulkActionTaskActions.vue?vue&type=template&id=01452c6e&scoped=true&"
import script from "./BulkActionTaskActions.vue?vue&type=script&lang=ts&"
export * from "./BulkActionTaskActions.vue?vue&type=script&lang=ts&"
import style0 from "./BulkActionTaskActions.vue?vue&type=style&index=0&id=01452c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01452c6e",
  null
  
)

export default component.exports